import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

const NO_REFRESH = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/forgot-password", "/auth/reset-password", "/auth/accept-invite", "/public/"];
let refreshing = null;
api.interceptors.response.use((r) => r, async (err) => {
  const cfg = err.config || {};
  const url = cfg.url || "";
  if (err.response?.status === 401 && !cfg._retried && !NO_REFRESH.some((p) => url.includes(p))) {
    cfg._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(cfg);
    } catch { /* refresh failed: fall through */ }
  }
  return Promise.reject(err);
});

export function formatApiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const brl = (v) =>
  "R$ " + Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Data de calendário local (navegador no fuso do operador) — evita o deslocamento de dia do toISOString() (UTC) após 21h
export const hojeISO = (d = new Date()) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
// Hora local (HH:mm) de um instante ISO com fuso (UTC armazenado → exibido no fuso do operador)
export const fmtTime = (s) => { if (!s || s.length <= 10) return ""; try { return new Date(s).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", hour12: false }).slice(0, 5); } catch { return s.slice(11, 16); } };
export const fmtDate = (s) => {
  if (!s) return "-";
  try {
    const d = new Date(s.length <= 10 ? s + "T00:00:00" : s);
    return d.toLocaleDateString("pt-BR");
  } catch {
    return s;
  }
};
// Identificação coerente: parcelas normais mantêm o nº do contrato; itens de acordo usam o contexto do acordo
export const rotuloParcela = (p) => {
  if (!p) return "";
  if (p.origem === "acordo_entrada") return "Entrada do acordo";
  if (p.origem === "acordo" && p.numero_acordo) return `Parcela ${p.numero_acordo}${p.acordo_total ? `/${p.acordo_total}` : ""} do acordo`;
  return `Parcela #${p.numero}`;
};
export const rotuloPagamento = (p) => {
  const r = p?.rotulo_parcela || "";
  if (r.startsWith("Entrada") || r.startsWith("Parcela")) return r;
  return `Parcela #${p?.numero_parcela}`;
};


api.interceptors.response.use((r) => r, (err) => {
  const d = err.response?.data?.detail;
  if (Array.isArray(d)) {
    err.response.data.detail = d.map((x) => `${(x.loc || []).slice(1).join(".")}: ${x.msg}`.replace(/^: /, "")).join("; ") || "Dados inválidos";
  } else if (d && typeof d === "object") {
    err.response.data.detail_obj = d;
    err.response.data.detail = d.mensagem || d.msg || d.detail || "Operação não permitida";
    if (Array.isArray(d.pendencias) && d.pendencias.length) err.response.data.detail += `\nPendências: ${d.pendencias.join("; ")}`;
  }
  if (err.response?.status === 403 && typeof err.response.data?.detail === "string") err.response.data.detail = err.response.data.detail.replace(/^Not authenticated$/, "Acesso negado");
  if (err.response?.status === 428 && !window.location.pathname.startsWith("/primeiro-acesso")) window.location.href = "/primeiro-acesso";
  if (err.response?.status === 402 && !window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/bloqueado")) {
    const det = err.response.data?.detail || "";
    if (det.includes("Teste encerrado")) window.location.href = "/bloqueado?m=teste";
    else if (det.includes("bloqueada")) window.location.href = "/bloqueado";
  }
  return Promise.reject(err);
});

window.addEventListener("unhandledrejection", (ev) => {
  const st = ev.reason?.response?.status;
  if (!ev.reason?.isAxiosError) return;
  ev.preventDefault();
  import("sonner").then(({ toast }) => toast.error(st === 403 ? "Acesso negado: sua função não tem permissão para esta área." : ev.reason.response?.data?.detail || "Não foi possível concluir a operação."));
});

export default api;
